import { gql } from '@apollo/client'

export const GET_PRODUCT_QUERY = gql`
  query getProduct(
    $sku: String!
    $currency: Currency!
    $country: Country!
    $locale: Locale!
  ) {
    product(sku: $sku) {
      productType {
        key
      }

      masterData {
        published
        current {
          name(locale: $locale)
          categories {
            name(locale: $locale)
          }
          descriptionAllLocales {
            locale
            value
          }
          variant(sku: $sku) {
            key
            attributesRaw(
              includeNames: [
                "customerAlerts"
                "productDetailPageUrl"
                "productTitle"
                "availableForSubscription"
              ]
            ) {
              name
              value
            }

            sku

            images {
              url
              label
            }

            price(currency: $currency, country: $country) {
              value {
                centAmount
                currencyCode
                fractionDigits
                type
              }
              discounted {
                value {
                  centAmount
                  currencyCode
                  fractionDigits
                  type
                }
              }
            }
            availability {
              channels {
                results {
                  channel {
                    id
                  }
                  availability {
                    availableQuantity
                    isOnStock
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
